import { EmailField, Stack, TextField } from "@telefonica/mistica";
import React from "react";
import { isEmailValid, isNameValid } from "../../../utils/validators";
import { strings } from "../../../localization";
import { formatCellphoneNumber, formatDocumentNumber, onlyNumber } from "../../../utils/formatters";
import { observer } from "mobx-react-lite";
export interface InputsRegistrationDataProps {
	documentNumber: string;
	name: string;
	email: string;
	phoneNumber: string;
	isDocumentNumberDisabled?: boolean;
	isNameDisabled?: boolean;
	isEmailDisabled?: boolean;
	isPhoneNumberDisabled?: boolean;
	onNameChange(value: string): void;
	onEmailChange(value: string): void;
}

export const InputsRegistrationData: React.FC<InputsRegistrationDataProps> = observer((props) => {
	const {
		documentNumber,
		phoneNumber,
		name,
		email,
		isDocumentNumberDisabled,
		isPhoneNumberDisabled,
		isNameDisabled,
		isEmailDisabled,
		onNameChange,
		onEmailChange,
	} = props;
	const { labelCpf, labelEmail, labelName, labelPhone, prefixPhone, errors } = strings.organisms.inputsRegistrationData;

	return (
		<Stack space={16}>
			<TextField
				maxLength={14}
				label={labelCpf}
				name="cpf"
				value={formatDocumentNumber(documentNumber)}
				disabled={isDocumentNumberDisabled}
				readOnly={isDocumentNumberDisabled}
				fullWidth
				data-cs-mask
			/>
			<TextField
				maxLength={15}
				prefix={prefixPhone}
				label={labelPhone}
				name="phone-number"
				value={formatCellphoneNumber(onlyNumber(phoneNumber))}
				disabled={isPhoneNumberDisabled}
				readOnly={isPhoneNumberDisabled}
				fullWidth
				data-cs-mask
			/>
			<TextField
				label={labelName}
				name="name"
				value={name}
				onChange={(e) => {
					onNameChange(e.target.value);
				}}
				error={!isNameValid(name) && name !== ""}
				helperText={!isNameValid(name) && name !== "" ? errors.invalidName : ""}
				fullWidth
				disabled={isNameDisabled}
				readOnly={isNameDisabled}
				data-cs-mask
			/>
			<EmailField
				label={labelEmail}
				name="e-mail"
				value={email}
				onChange={(e) => {
					onEmailChange(e.target.value);
				}}
				error={!isEmailValid(email) && email !== ""}
				helperText={!isEmailValid(email) && email !== "" ? errors.invalidEmail : ""}
				fullWidth
				disabled={isEmailDisabled}
				readOnly={isEmailDisabled}
				data-cs-mask
			/>
		</Stack>
	);
});
